export function formatTime(seconds) {
  if (!seconds || isNaN(seconds) || !isFinite(seconds)) return "00:00.00";
  const s = Math.max(0, seconds);
  const mm = Math.floor(s / 60);
  const ss = Math.floor(s % 60);
  const cs = Math.floor((s - Math.floor(s)) * 100);
  return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}.${String(
    cs
  ).padStart(2, "0")}`;
}

export function detectYouTubeId(url) {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
}

export function isYouTubeUrl(url) {
  if (!url) return false;
  return /(?:youtube\.com|youtu\.be)/.test(url);
}

export function inferSourceFromUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();
  if (isYouTubeUrl(trimmed)) {
    return { type: "youtube", url: trimmed, name: "YouTube" };
  }
  // try to extract filename
  try {
    const u = new URL(trimmed);
    const parts = u.pathname.split("/").filter(Boolean);
    const name = parts[parts.length - 1] || u.hostname;
    return { type: "url", url: trimmed, name };
  } catch {
    return null;
  }
}
